import {FETCH_FEATURE_STATUS_CALL_SUCCESS} from "../actions/ConfigActions";

export default function optionsReducer(state = {}, action) {
    switch (action.type) {
        case FETCH_FEATURE_STATUS_CALL_SUCCESS:
            return {
                ...state,
                featureStatus: {...state.featureStatus, ...action.featureStatus},
                loading: false
            }
        default:
            // ALWAYS have a default case in a reducer
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/ConfigReducer.js